import { type MaybeRefOrGetter, onMounted, toValue } from 'vue';

type MissingNameWarning = {
  isNamed: MaybeRefOrGetter<boolean>;
  component: string;
  role: string;
  hint: string;
};

export function useMissingNameWarning({
  isNamed,
  component,
  role,
  hint,
}: MissingNameWarning) {
  onMounted(() => {
    if (import.meta.env.DEV && !toValue(isNamed)) {
      console.warn(
        `${component} has no accessible name: ${hint}. It will be announced as an unnamed ${role}.`,
      );
    }
  });
}
